export default function ContactSection() {
  return (
    <section id="contact" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">联系我们</h2>
          <p className="text-foreground-400 text-sm">意见反馈、内容投稿、商务合作，期待你的声音</p>
        </div>
        <div className="max-w-[700px] mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-300/40 p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 rounded-xl bg-background-200/50 border border-background-300/30">
                <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center mx-auto mb-3 border border-primary-500/20">
                  <i className="ri-mail-line text-xl text-primary-400"></i>
                </div>
                <div className="font-medium text-foreground-100 text-sm mb-1">意见反馈</div>
                <div className="text-xs text-foreground-500 break-all">feedback@bananatv.com</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-200/50 border border-background-300/30">
                <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center mx-auto mb-3 border border-accent-500/20">
                  <i className="ri-chat-3-line text-xl text-accent-400"></i>
                </div>
                <div className="font-medium text-foreground-100 text-sm mb-1">内容投稿</div>
                <div className="text-xs text-foreground-500 break-all">content@bananatv.com</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-200/50 border border-background-300/30">
                <div className="w-10 h-10 rounded-lg bg-secondary-500/10 flex items-center justify-center mx-auto mb-3 border border-secondary-500/20">
                  <i className="ri-briefcase-line text-xl text-secondary-400"></i>
                </div>
                <div className="font-medium text-foreground-100 text-sm mb-1">商务合作</div>
                <div className="text-xs text-foreground-500 break-all">biz@bananatv.com</div>
              </div>
            </div>
            <div className="text-center pt-6 border-t border-background-300/40">
              <p className="text-sm text-foreground-400 mb-4">或通过以下渠道关注我们，获取最新影视资讯</p>
              <div className="flex items-center justify-center gap-4">
                <a href="#hero" className="w-10 h-10 rounded-full bg-background-200 hover:bg-background-300 flex items-center justify-center border border-background-400/30 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg text-foreground-300"></i>
                </a>
                <a href="#hero" className="w-10 h-10 rounded-full bg-background-200 hover:bg-background-300 flex items-center justify-center border border-background-400/30 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg text-foreground-300"></i>
                </a>
                <a href="#hero" className="w-10 h-10 rounded-full bg-background-200 hover:bg-background-300 flex items-center justify-center border border-background-400/30 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg text-foreground-300"></i>
                </a>
                <a href="#hero" className="w-10 h-10 rounded-full bg-background-200 hover:bg-background-300 flex items-center justify-center border border-background-400/30 transition-colors cursor-pointer">
                  <i className="ri-links-line text-lg text-foreground-300"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}